// Utility functions for security-related UI helpers

export function getSeverityColor(severity: string): string {
  switch (severity.toUpperCase()) {
    case "CRITICAL":
      return "bg-red-100 text-red-800 hover:bg-red-100";
    case "HIGH":
      return "bg-orange-100 text-orange-800 hover:bg-orange-100";
    case "MEDIUM":
      return "bg-yellow-100 text-yellow-800 hover:bg-yellow-100";
    case "LOW":
      return "bg-blue-100 text-blue-800 hover:bg-blue-100";
    default:
      return "bg-gray-100 text-gray-800 hover:bg-gray-100";
  }
}

export function getStatusColor(status: string): string {
  switch (status.toLowerCase()) {
    case "success":
    case "protected":
      return "text-green-600 bg-green-50";
    case "blocked":
    case "warning":
    case "vulnerable":
      return "text-orange-600 bg-orange-50";
    default:
      return "text-gray-600 bg-gray-50";
  }
}

export function getIssueStatusColor(status: string): string {
  const colors: Record<string, string> = {
    OPEN: "bg-red-100 text-red-800 border-red-300",
    IN_REVIEW: "bg-yellow-100 text-yellow-800 border-yellow-300",
    RESOLVED: "bg-green-100 text-green-800 border-green-300",
    FALSE_POSITIVE: "bg-gray-100 text-gray-800 border-gray-300",
  };
  return colors[status] || "bg-gray-100 text-gray-800 border-gray-300";
}

export function getStatusBorderColor(status: string): string {
  switch (status.toLowerCase()) {
    case "protected":
      return "border-green-500 bg-green-50 text-green-900";
    case "vulnerable":
      return "border-red-500 bg-red-50 text-red-900";
    case "warning":
      return "border-orange-500 bg-orange-50 text-orange-900";
    default:
      return "border-gray-500 bg-gray-50 text-gray-900";
  }
}

export function getRiskColor(risk: string): string {
  switch (risk.toLowerCase()) {
    case "critical":
      return "bg-red-100 text-red-800";
    case "high":
      return "bg-orange-100 text-orange-800";
    case "medium":
      return "bg-yellow-100 text-yellow-800";
    case "low":
      return "bg-blue-100 text-blue-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
}

export function getConnectorColor(risk: string): string {
  switch (risk.toLowerCase()) {
    case "critical":
      return "border-red-500";
    case "high":
      return "border-orange-500";
    case "medium":
      return "border-yellow-500";
    case "low":
      return "border-blue-500";
    default:
      return "border-gray-300";
  }
}

export function getRiskScoreColor(score: number): string {
  if (score >= 0.9) return "text-red-600";
  if (score >= 0.7) return "text-orange-600";
  if (score >= 0.5) return "text-yellow-600";
  return "text-blue-600";
}

export function formatRiskScore(score: number): string {
  return `${Math.round(score * 100)}%`;
}

export function getRiskBadgeHexColor(risk: string): string {
  switch (risk.toLowerCase()) {
    case "critical":
      return "#dc2626";
    case "high":
      return "#ea580c";
    case "medium":
      return "#ca8a04";
    case "low":
      return "#2563eb";
    default:
      return "#6b7280";
  }
}
